<template>
<div>
    <div class="container text-center mb-5">
        <h1 class="bold300 text-uppercase" style=" font-weight:500;">Inventario de Bienes</h1>
    </div>
      <nav>
        <div class="nav nav-movil nav-tabs" id="nav-tab" role="tablist">
            <a
                class="nav-link"
                @click="itemActive1 = true, itemActive2 = false, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive1==false && (itemActive2))? 'darkInactivo' : ''
                ]"
                id="nav-bienesPatrimonio-tab"
                data-toggle="tab"
                href="#nav-bienesPatrimonio"
                role="tab"
                aria-controls="nav-bienesPatrimonio"
                aria-selected="true"
                > <span class="verPc"><p class="m-0">Bienes Patrimonio</p></span><span class="verMovil"><p class="m-0">Patrimonio</p></span>
            </a>
            <a
                class="nav-link"
                @click="itemActive1 = false, itemActive2 = true, itemActive3 = false"
                :class="[
                  (!modoDark_var && itemActive2 && !itemActive1)? 'active' : '',
                  (modoDark_var && itemActive2 && !itemActive1)? 'DarkActive active' : '',
                  (modoDark_var && itemActive2==false && (itemActive1))? 'darkInactivo' : ''
                ]"
                id="nav-mobiliarioEquipo-tab"
                data-toggle="tab"
                href="#nav-mobiliarioEquipo"
                role="tab"
                aria-controls="nav-mobiliarioEquipo"
                aria-selected="false"
                >
                <span class="verPc"><p class="m-0">Mobiliario y Equipo</p></span><span class="verMovil"><p class="m-0">Mobiliario</p></span>
            </a>
            <a
              class="nav-link"
              @click="itemActive1 = false, itemActive2 = false, itemActive3 = true"
              :class="[
                  (!modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'active' : '',
                  (modoDark_var && itemActive3 && !itemActive1 && !itemActive2)? 'DarkActive active' : '',
                  (modoDark_var && itemActive3==false && (itemActive1 || itemActive2))? 'darkInactivo' : ''
              ]"
              id="nav-vehicular-tab"
              data-toggle="tab"
              href="#nav-vehicular"
              role="tab"
              aria-controls="nav-vehicular-tab"
              aria-selected="false"
              >
              <span class="verPc"><p class="m-0">Inventario Vehicular</p></span><span class="verMovil"><p class="m-0">Inventario Vehicular</p></span>
          </a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
          <div :class="[(itemActive1 && !itemActive2 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-bienesPatrimonio" role="tabpanel" aria-labelledby="nav-bienesPatrimonio-tab">

              <div class="card">
                  <div class="card-body">
                      <div class="row card-body">
                          <div class="container text-left mb-3">
                              <h6>Relación de bienes que componen su patrimonio</h6>
                          </div>
                          <select2Filtros id="selectFiltroPatrimonio" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="data" @seleccionado="responseSelectComponent = $event" @titulo="textoTitulo = $event" />
                      </div>
                  </div>
              </div>
              <!-- componente aqui -->
            <tabla-simple id="tabla1Filtros" class="mt-5" :titulo="textoTitulo" :datos="responseSelectComponent" />
            <span v-if="responseSelectComponent" v-html="DateFormatText(responseSelectComponent.fecha_actualizacion)"></span>
            <span v-else v-html="DateFormatText(fecha_actualizacion_externa)"></span>
          </div>
          <div :class="[(itemActive2 && !itemActive1 && !itemActive3)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-mobiliarioEquipo" role="tabpanel" aria-labelledby="nav-mobiliarioEquipo-tab">
            <div class="card">
              <div class="card-body">
                <div class="row card-body">
                  <div class="container text-left mb-3">
                      <h6>Inventario de Mobiliario y Equipo</h6>
                  </div>
                  <select2Filtros id="MobiliarioEquipo" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="mobiliarioEquipo" @seleccionado="responseSelectComponent2 = $event" @titulo="textoTitulo2 = $event" />
                </div>
              </div>
            </div>
            <!-- aqui puede estar tu componente, o tu info -->
            <tabla-simple class="mt-5" :titulo="`Inventario de Mobiliario y Equipo ${textoTitulo2} `" :datos="responseSelectComponent2" />
            <span v-if="responseSelectComponent2" v-html="DateFormatText(responseSelectComponent2.fecha_actualizacion)"></span>
            <span v-else v-html="DateFormatText(fecha_actualizacion_externa2)"></span>
          </div>
          <div :class="[(itemActive3 && !itemActive1 && !itemActive2)? 'tab-pane fade show active' : 'tab-pane fade',]" id="nav-vehicular" role="tabpanel" aria-labelledby="nav-vehicular-tab">
          <div class="card">
              <div class="card-body">
                  <div class="row card-body">
                    <div class="container text-left mb-3">
                      <h6>Inventario Vehicular</h6>
                  </div>
                  <select2Filtros id="invetarioVehicular" placeholder1="Seleccione año" placeholder2="Seleccione el trimestre" :data="mobiliarioVehicular" @seleccionado="responseSelectComponent3 = $event" @titulo="textoTitulo3 = $event" />
                  </div>
              </div>
          </div>
          <!-- <pre>{{mobiliarioVehicular}}</pre> -->
          <tabla-simple id="tablaVehiular" class="mt-5" :titulo="`Inventario Vehicular ${textoTitulo3} `" :datos="responseSelectComponent3" />
          <span v-if="responseSelectComponent3" v-html="DateFormatText(responseSelectComponent3.fecha_actualizacion)"></span>
          <span v-else v-html="DateFormatText(fecha_actualizacion_externa3)"></span>
        </div>
      </div>
  </div>
</template>
<script>
// import botonAtras from '@/views/button-atras.vue'
import('@/assets/css/tablaTypeFiles.css');

import mapFun from '@/common/map-fn-types.js';
import ArmonizacionContableSH from "@/services/ArmonizacionContable/secretariaHacienda/ArmonizacionCSHacienda.service.js";
const _serviciosArmonizacionContableSH = new ArmonizacionContableSH();
import botonAtras from '@/views/button-atras.vue'
import tablaSimple from '@/components/tablaSimple.vue';
import select2Filtros from '@/components/selectCompuesto.vue'
import { mapState } from "vuex";
import('@/assets/css/tab.css');
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
  name: "contenedorInventarioBienes",
  components: { botonAtras, tablaSimple, select2Filtros },
  computed:{ ...mapState(['modoDark_var']) },
  mixins: [DateFormat],
  data() {
    return{
      itemActive1: true,
        itemActive2: false,
        itemActive3: false,

        data: [],
        mobiliarioEquipo: [],
        mobiliarioVehicular: [],
        textoTitulo: '',
        textoTitulo2: '',
        textoTitulo3: '',

        responseSelectComponent: '',
        responseSelectComponent2: '',
        responseSelectComponent3: '',

        fecha_actualizacion_externa: '',
        fecha_actualizacion_externa2: '',
        fecha_actualizacion_externa3: ''
    }
  },
  async created() {
    await this.getIBPatrimonio();
    await this.getIBEquipo();
    await this.getIBVehicular();
  },
  methods: {
    async getIBPatrimonio() {
          try {
              const response = await _serviciosArmonizacionContableSH.getIBPatrimonio(mapFun.SHPatrimonio);
              // console.log(response);
              this.data = response.data;
              this.fecha_actualizacion_externa = this.data[this.data.length-1].fecha_actualizacion;

              this.data = this.data.reverse();
              this.data.forEach(e => {
                e.contenido.reverse();
              });

              this.data = this.data.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });


          } catch (error) {
              console.log('error', error.message);
          }
      },
      async getIBEquipo() {
          try {
              const response = await _serviciosArmonizacionContableSH.getMobiliarioEquipo(mapFun.MobiliarioEquipo);
              // console.log(response);
              this.mobiliarioEquipo = response.data;
              this.fecha_actualizacion_externa2 = this.mobiliarioEquipo[this.mobiliarioEquipo.length-1].fecha_actualizacion;

              this.mobiliarioEquipo = this.mobiliarioEquipo.reverse();
              this.mobiliarioEquipo.forEach(e => {
                e.contenido.reverse();
              });

              this.mobiliarioEquipo = this.mobiliarioEquipo.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });

          } catch (error) {
              console.log('error', error.message);
          }
      },
      async getIBVehicular() {
          try {
              const response = await _serviciosArmonizacionContableSH.getInventarioVehicular(mapFun.InventarioVehicular);
              // console.log(response);
              this.mobiliarioVehicular = response.data;
              this.fecha_actualizacion_externa3 = this.mobiliarioVehicular[this.mobiliarioVehicular.length-1].fecha_actualizacion;

              this.mobiliarioVehicular = this.mobiliarioVehicular.reverse();
              // this.mobiliarioVehicular.forEach(e => {
              //   e.contenido.reverse();
              // });

              this.mobiliarioVehicular = this.mobiliarioVehicular.map(function (e) {
                return {
                    id:                   e.id,
                    text:                 e.titulo,
                    fecha_actualizacion:  e.fecha_actualizacion,
                    seccion:              e.contenido
                };
              });

          } catch (error) {
              console.log('error', error.message);
          }
      },
  }
}
</script>
